import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { CommonModule } from '@angular/common'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { ProposalStatusService } from '../../../core/services/proposal/proposal-status/proposal-status.service'
import { PaymentMethodsService } from '../../../core/services/payment/payment-methods/payment-methods.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ModalLegalEntitySubClientComponent } from '../../customer/modal_subclient/modal-legal-entity-subclient/modal-legal-entity-subclient.component'
import { ModalConsultantClientComponent } from '../../person/modal-consultant-client/modal-consultant-client.component'
import { ModalEmployeeConsultantComponent } from '../../employee/modal-employee-consultant/modal-employee-consultant.component'
/* import { ItemProposalCreateComponent } from '../item-proposal-create/item-proposal-create.component' */
import { convertCurrency } from '../../../shared/utils/utils'
import moment from 'moment'
import { IntegerInputDirective } from '../../../shared/directives/IntegerInput'
import { MatDivider } from '@angular/material/divider'
import { DecimalInputDirective } from '../../../shared/directives/decimalInput'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { LegalEntityClientComponent } from '../../../pages/customer/legal-entity-client/legal-entity-client.component'
import { MatTab, MatTabGroup } from '@angular/material/tabs'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { FinancialOperationService } from '../../../core/services/financial/financial-operation/financial-operation.service'

// Interface para tipagem do Status de Operação
interface OperationStatus {
  id: number
  codigo: string
  descricao: string
}

@Component({
  selector: 'financial-operation-create',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    /*  ItemProposalCreateComponent, */
    IntegerInputDirective,
    NgxMaskDirective,
    MatDivider,
    DecimalInputDirective,
    LegalEntityClientComponent,
    MatTab,
    MatTabGroup,
    ContactClientCreateComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatAccordion,
    CommonModule,
  ],
  templateUrl: './financial-operation-create.component.html',
  styleUrl: './financial-operation-create.component.scss',
  providers: [
    FinancialOperationService,
    ProposalStatusService,
    PaymentMethodsService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class FinancialOperationCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private financialOperationService: FinancialOperationService,
    private proposalStatusService: ProposalStatusService,
    private paymentMethodsService: PaymentMethodsService,
    private commissionDividerService: CommissionDividerService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<FinancialOperationCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data && data.user) {
      this.item = { user: true, data: data.item }
    }
  }

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  @Output() responseEdit = new EventEmitter()

  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  idClient: number = -1

  ListPaymentMethods: any[] = []
  ListOperationStatus: any[] = []

  ListCommission: any[] = [
    { value: 0, description: 'tg.mob', disabled: false },
    { value: 1, description: 'Cliente', disabled: true },
    { value: 2, description: 'Personalizado', disabled: false },
  ]

  commissionDividerClient: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  commissionDividerTg: any = {
    taxa: 0,
    divisor: 0,
    comissao: 0,
  }

  ListItemsOperation: any[] = []

  clientSelected: any = {}
  subClientSelected: any = {}
  consultantClientSelected: any = {}
  employeeConsultantSelected: any = {}

  ngOnInit(): void {
    this.getStatusOperation()
    this.getCommissionDivider()
    this.createForm()

    // Log para debug - verificar se a lista foi carregada
    console.log('ListOperationStatus carregada:', this.ListOperationStatus)
  }

  getStatusOperation() {
    this.proposalStatusService.listProposalStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListOperationStatus = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  // NOVO MÉTODO - Para buscar Status de Operação de uma API (opcional)
  getOperationStatus() {
    // Se você tiver um service específico para status de operação, descomente e ajuste:
    /*
    this.operationStatusService.listOperationStatus().subscribe({
      next: (response: ResponseRequestModel) => {
        this.ListOperationStatus = response.data;
        console.log('Status de operação carregados da API:', this.ListOperationStatus);
      },
      error: (err: ResponseRequestModel) => {
        console.error('Erro ao carregar status de operação:', err);
        // Manter os dados estáticos como fallback
      },
    });
    */
  }

  getCommissionDivider(id: number = -1) {
    if (id == -1) {
      this.commissionDividerService.getCommissionDividerDefault().subscribe({
        next: (response: ResponseRequestModel) => {
          this.commissionDividerTg = {
            taxa:
              response && response.data && response.data.taxa
                ? response.data.taxa
                : 0,
            divisor:
              response && response.data && response.data.divisor
                ? response.data.divisor
                : 1,
            comissao:
              response && response.data && response.data.comissao
                ? response.data.comissao
                : 0,
          }
          // this.commissionDividerTg = {
          //   taxa: response.data.taxa,
          //   divisor: response.data.divisor,
          //   comissao: response.data.comissao,
          // }
          this.fillCommission(this.commissionDividerTg)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    } else {
      this.commissionDividerService
        .getCommissionDividerbyClientId(id)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            console.log('response', response)
            if (response.data) {
              this.commissionDividerClient = {
                taxa:
                  response && response.data && response.data.taxa
                    ? response.data.taxa
                    : 0,
                divisor:
                  response && response.data && response.data.divisor
                    ? response.data.divisor
                    : 1,
                comissao:
                  response && response.data && response.data.comissao
                    ? response.data.comissao
                    : 0,
              }
              this.ListCommission[1].disabled = false
              this.form.get('typeCommission')!.setValue(1)
              this.fillCommission(this.commissionDividerClient)
            } else {
              this.commissionDividerClient = {
                taxa: 0,
                divisor: 1,
                comissao: 0,
              }
              this.fillCommission(this.commissionDividerTg)
              this.form.get('typeCommission')!.setValue(0)
              this.ListCommission[1].disabled = true
            }
          },
          error: (err: ResponseRequestModel) => {
            console.error(err)
          },
          complete: () => {},
        })
    }
  }

  fillCommission(commission: any, clear: boolean = false) {
    if (clear == false) {
      this.form
        .get('commission')!
        .setValue(convertCurrency(commission.comissao))
      this.form.get('commission')!.disable()
      this.form.get('tax')!.setValue(convertCurrency(commission.taxa))
      this.form.get('tax')!.disable()
      this.form.get('divider')!.setValue(convertCurrency(commission.divisor))
      this.form.get('divider')!.disable()
    } else {
      this.form.get('commission')!.setValue(convertCurrency(0))
      this.form.get('commission')!.enable()
      this.form.get('tax')!.setValue(convertCurrency(0))
      this.form.get('tax')!.enable()
      this.form.get('divider')!.setValue(convertCurrency(0))
      this.form.get('divider')!.enable()
    }
  }

  onSelectionChangeType(event: MatSelectChange) {
    if (event.value == 0) {
      this.fillCommission(this.commissionDividerTg)
    } else if (event.value == 1) {
      this.fillCommission(this.commissionDividerClient)
    } else {
      this.fillCommission('', true)
    }
  }

  // NOVO MÉTODO - Para tratar mudança no select de Status de Operação
  onOperationStatusChange(event: MatSelectChange) {
    const selectedStatus = this.ListOperationStatus.find(
      (status) => status.id === event.value,
    )
    console.log('Status de operação selecionado:', selectedStatus)

    // Aqui você pode adicionar lógica específica baseada no status selecionado
    // Por exemplo, habilitar/desabilitar outros campos, etc.
  }

  getPaymentMethod(id: number) {
    this.ListPaymentMethods = []
    this.paymentMethodsService.listPaymentMethodsByPerson(id).subscribe({
      next: (response: ResponseRequestModel) => {
        console.log(response.data)
        this.ListPaymentMethods = response.data
        this.form.get('paymentMethod')!.enable()
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {
        this.form.get('paymentMethod')!.enable()
      },
    })
  }

  createFinancialOperation() {
    this.loading = true
    const model = this.createModel()
    console.log('model', model)
    this.financialOperationService.createFinancialOperation(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      financialOperation: {
        clienteId: this.clientSelected.id,
        subClienteId: this.subClientSelected.id ?? 0,
        consultorId: this.consultantClientSelected.consultorId ?? 0,
        nomeEvento: this.form.get('eventName')?.value ?? '',
        formaPagamentoId: this.form.get('paymentMethod')?.value ?? '',
        consultorComercialId: this.employeeConsultantSelected.id ?? 0,
        statusOperacao: this.form.get('statusOperation')?.value ?? '', // NOVO CAMPO
        dataInicio: moment(this.form.get('dateStart')!.value).format(
          'DD/MM/YYYY',
        ),
        dataFim: moment(this.form.get('dateEnd')!.value).format('DD/MM/YYYY'),
        quantidadePassageiros:
          parseInt(this.form.get('numPassengers')?.value) ?? 0,
        solicitante: this.form.get('requesterName')?.value ?? '',
        solicitanteEmail: this.form.get('requesterEmail')?.value ?? '',
        solicitanteTelefone: this.form.get('requesterPhone')?.value ?? '',
      },
      itens: this.getItemsProposal(),
    }
  }

  getItemsProposal() {
    let items = []

    for (let index = 0; index < this.ListItemsOperation.length; index++) {
      const element = this.ListItemsOperation[index]
      let itineraries = []
      for (
        let indexItineraries = 0;
        indexItineraries < element.intinerarios.length;
        indexItineraries++
      ) {
        const elementItineraries = element.intinerarios[indexItineraries]
        itineraries.push({
          localParada: elementItineraries.descricao,
          cep: elementItineraries.cep,
          logradouro: elementItineraries.logradouro,
          numero: elementItineraries.numero,
          bairro: elementItineraries.bairro,
          latitude:
            elementItineraries.latitude != ''
              ? elementItineraries.latitude
              : null,
          longitude:
            elementItineraries.longitude != ''
              ? elementItineraries.longitude
              : null,
          cidade: elementItineraries.cidade,
          estado: elementItineraries.estado,
          complemento: elementItineraries.complemento,
        })
      }
      items.push({
        tarifarioId: element.tarifarioId != '' ? element.tarifarioId : null,
        origemId: element.origemId,
        destinoId: element.destinoId,
        tipoServicoId: element.tipoServicoId,
        servicoId: element.servicoId,
        tipoVeiculoId: element.tipoVeiculoId,
        tipoMotoristaId: element.tipoMotoristaId,

        quantidadePassageiros: element.numPessoas,
        quantidadeVeiculos: element.numVeiculos,

        valorUnitario: convertCurrency(element.vendaUnitario),
        valorVenda: convertCurrency(element.vendaSemTaxa),
        valorComTaxa: convertCurrency(element.venda),
        valorTaxa: convertCurrency(element.valorTaxa),
        valorKmVenda: convertCurrency(element.saleKmExtra),
        valorHoraVenda: convertCurrency(element.saleHoraExtra),

        isPermuta: element.isPermuta ? 'S' : 'N',
        isComissiona: element.isCortesia ? 'S' : 'N',
        isCortesia: element.isCortesia ? 'S' : 'N',

        dataInicio: element.dataInicioFormatada,
        horaInicio: element.horaInicio + ':00',

        dataFinal: element.dataFinalFormatada,
        horaFinal: element.horaFinal + ':00',

        tipoComissao: element.tipoComissao,
        taxa: convertCurrency(element.taxa),
        divisor: convertCurrency(element.divisor),
        comissao: convertCurrency(element.comissao),

        itinerarios: itineraries,
      })
    }

    return items
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      statusProposal: ['', [Validators.required]],
      statusOperation: [''], // NOVO CAMPO para Status de Operação
      eventName: ['', [Validators.required]],
      dateStart: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      client: ['', [Validators.required]],
      subClient: [''],
      consultant: ['', [Validators.required]],
      employeeConsultant: [''],
      serviceFee: [convertCurrency(0)],
      grandTotal: [convertCurrency(0), [Validators.required]],
      numPassengers: ['', [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      requesterName: ['', [Validators.required]],
      requesterEmail: ['', [Validators.required]],
      requesterPhone: ['', [Validators.required]],
      typeCommission: [0],
      commission: [''],
      divider: [''],
      tax: [''],
    })

    this.form.get('statusProposal')!.disable()
    this.form.get('subClient')!.disable()
    this.form.get('consultant')!.disable()
    this.form.get('grandTotal')!.disable()
    this.form.get('paymentMethod')!.disable()
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.clientSelected.id) {
            this.clientSelected = response.selection
            this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
            this.clearItem(['subClient', 'consultant', 'paymentMethod'])
            this.form.get('subClient')!.enable()
            this.form.get('consultant')!.enable()
            this.getPaymentMethod(this.clientSelected.pessoaId)
            this.idClient = this.clientSelected.id
            this.getCommissionDivider(this.clientSelected.id)
          }
        } else {
          this.clearItem(['client', 'subClient', 'consultant', 'paymentMethod'])
          this.form.get('subClient')!.disable()
          this.form.get('consultant')!.disable()
          this.form.get('paymentMethod')!.disable()
          this.idClient = -1
          this.commissionDividerClient = {
            taxa: 0,
            divisor: 0,
            comissao: 0,
          }
          this.fillCommission(this.commissionDividerTg)
          this.form.get('typeCommission')!.setValue(0)
          this.ListCommission[1].disabled = true
        }
      }
    })
  }

  addSubClient() {
    console.log(this.clientSelected.id)

    const dialogRef = this.dialog.open(ModalLegalEntitySubClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: this.clientSelected.id,
        item: this.subClientSelected,
        multiSelect: false,
      },
    })

    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.subClientSelected.id) {
            this.subClientSelected = response.selection
            this.form
              .get('subClient')!
              .setValue(this.subClientSelected.nomeFantasia)
            this.clearItem(['consultant', 'paymentMethod'])
            this.getPaymentMethod(this.subClientSelected.pessoaId)
            this.idClient = this.subClientSelected.id
            this.getCommissionDivider(this.subClientSelected.id)
          }
        } else {
          this.clearItem(['subClient', 'consultant', 'paymentMethod'])
          this.getPaymentMethod(this.clientSelected.id)
          this.idClient = this.clientSelected.id
          this.getCommissionDivider(this.clientSelected.id)
        }
      }
    })
  }

  addConsultantClient() {
    let idClient =
      this.subClientSelected && this.subClientSelected.id
        ? this.subClientSelected.id
        : this.clientSelected.id
    const dialogRef = this.dialog.open(ModalConsultantClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: idClient,
        item: {
          id: this.consultantClientSelected.consultorId,
          description: this.consultantClientSelected,
        },
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        console.log('response', response)
        if (response.remove == false) {
          if (
            response.selection.consultorId !=
            this.consultantClientSelected.consultorId
          ) {
            this.consultantClientSelected = response.selection
            this.form
              .get('consultant')!
              .setValue(this.consultantClientSelected.nome)
          }
        } else {
          this.clearItem(['consultant'])
        }
      }
    })
  }

  addEmployeeConsultant() {
    const dialogRef = this.dialog.open(ModalEmployeeConsultantComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.employeeConsultantSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.form
            .get('employeeConsultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearItem(['employeeConsultant'])
        }
      }
    })
  }

  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
    if (items.includes('consultant')) {
      this.consultantClientSelected = {}
      this.form.get('consultant')!.setValue('')
    }
    if (items.includes('employeeConsultant')) {
      this.employeeConsultantSelected = {}
      this.form.get('employeeConsultant')!.setValue('')
    }
    if (items.includes('paymentMethod')) {
      this.ListPaymentMethods = []
      this.form.get('paymentMethod')!.setValue('')
    }
    // NOVO - Para limpar o status de operação se necessário
    if (items.includes('statusOperation')) {
      this.form.get('statusOperation')!.setValue('')
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }

  getList(list: any[]) {
    this.ListItemsOperation = list
    this.updateGrandTotal()
    this.checkItensOperation()
    console.log('list', this.ListItemsOperation)
  }

  checkItensOperation() {
    console.log('list', this.ListItemsOperation)
  }

  updateGrandTotal() {
    let totalSale = this.ListItemsOperation.reduce(
      (total, ele) => total + convertCurrency(ele.venda),
      0,
    )
    this.form.get('grandTotal')!.setValue(convertCurrency(totalSale))
  }

  // NOVO MÉTODO - Para obter o status selecionado (útil para outros métodos)
  getSelectedOperationStatus(): OperationStatus | undefined {
    const selectedId = this.form.get('statusOperation')?.value
    return this.ListOperationStatus.find((status) => status.id === selectedId)
  }

  // NOVO MÉTODO - Para resetar o formulário (melhorado)
  resetForm() {
    this.form.reset()
    this.clientSelected = {}
    this.subClientSelected = {}
    this.consultantClientSelected = {}
    this.employeeConsultantSelected = {}
    this.ListPaymentMethods = []
    this.ListItemsOperation = []

    // Reabilitar campos que precisam estar habilitados por padrão
    this.form.get('statusOperation')?.enable()

    // Definir valores padrão
    this.form.get('typeCommission')?.setValue(0)
    this.form.get('serviceFee')?.setValue(convertCurrency(0))
    this.form.get('grandTotal')?.setValue(convertCurrency(0))
  }
}
